const fetchMiddleware = store => next => action => {
  next(action)
}

export default fetchMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/fetch.js